exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-critics-index-tsx": () => import("./../../../src/pages/critics/index.tsx" /* webpackChunkName: "component---src-pages-critics-index-tsx" */),
  "component---src-pages-films-index-tsx": () => import("./../../../src/pages/films/index.tsx" /* webpackChunkName: "component---src-pages-films-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

